import React, { Component } from 'react'
import { withTranslation } from "react-i18next"
import { LocalStorageService, SignatureRequestService, UserDocService, SignatureTypesService, WorkflowService, WorkflowMessagesService, NotificationResendService, SignerService, UserService, BovedaApi, ClientService } from "../../../services"
import { DetailSignatureView } from '../../views'
import { getNavigatorTimezone, limitExpirationDateInContract, dateInDialogChanceDate, getStampTimeAndTimezone, convertToStandarDate } from '../../../utils'
import { socket } from "../../../Context"
import moment from 'moment'
import { SignatureRequestValidator } from '../../../validators'
import { UploadIdentityDocumentAction } from '../../actions'
import hash from "object-hash"
import StandardDates from '../../../utils/StandardDates.util'


class DetailSignatureAction extends Component {
  constructor(props) {
    super(props)
    this.state = {
      token: {},
      user: {},
      isLoadingView: false,
      showErrorRequesting: false,
      messageError: '',
      messageComplete: '',
      showLoadingRequesting: false,
      showCompletedRequesting: false,
      showWarningRequesting: false,
      messageWarning: "",
      isWarnign: false,
      titleDialog: '',
      signatureRequestInfo: {},
      signatureRequestId: '',
      signatureTypes: {},
      usersChat: {},
      conversation: [],
      membersChat: [],
      signers: [],
      userCanEditExpirationDate: false,
      expirationDate: '',
      visibleExpirationDate: false,
      limitExpirationDate: '',
      signStatusName: '',
      signStatusColor: '#2196F3',
      isSignRequestPending: false,
      isSignRequestReject: false,
      signatureImg: null,
      ineFrontImg: null,
      ineBackImg: null,
      imgLoading: true,
      requireSignSupport: false,
      authorizerCanSign: false,
      workflowContract: {},
      completedRequest: false,
      userCanSign: "",
      visibleAccept: false,
      visibleReject: false,
      errorFileKey: false,
      errorFileCer: false,
      errorPassword: false,
      errorTextArea: false,
      userRequestingSign: "",
      currentUser: {},
      isShowAutorizationModal: false,
      imgSignature: null,
      allSignatures: [],
      signRequestPDF: "",
      signatureImgeData: {},
      passwordKey: "",
      passwordReliable: "",
      selectedFileKey: null,
      selectedFileCer: null,
      tokenUserNames: "",
      tokenUserLastnames: "",
      currentUserName: "",
      dataItem: {},
      imageWidth: 450,
      pdfWidth: 170,
      showBtnNotify: true,
      idPrecharge: null,
      idVault: 0,
      visibleDialogResendSignatureRequest: false,
      userCanResendInformation: false,
      visibleDialogReactivateSignatureRequest: false,
      signRequestIsExpired: false,
      userHasPfx: false,
      userPfx: "",
      newSign: true,
      selectedFileKeyName: "",
      selectedFileCerName: "",
      signgRequestIsPackage: false,
      documentsPackage: [],
      userCanCancelSignRequest: false,
      visibleDialogDeleteRequest: false,
      commentsDelete: '',
      signRequestHasAlmostASign: false,
      documentNameToShowInSign: '',
      showCancellationReason: false,
      cancellationReason: '',
      dateLimitTypeDate: '',
      showNotifyButton: false,
      language: 'es',
      titleHeader: '',
      workflowStatusCurrent: 0,
      showBtnNext: false,
      showBtnReject: false,
      labelBtnNext: '',
      labelBtnReject: '',
      nextImage: '',
      isMobile: false,
      step: "sign",
      userMultipleSign: false,
      stampVolume: "",
      includesMessageCertificate: false
    }
  }

  token = {}
  user = {}
  url = process.env.REACT_APP_MIFIRMA_API
  localStorageService = new LocalStorageService()
  signatureRequestService = new SignatureRequestService(this.url)
  signatureTypesService = new SignatureTypesService(this.url)
  workflowService = new WorkflowService(this.url)
  workflowMessagesService = new WorkflowMessagesService(this.url)
  notifService = new NotificationResendService(process.env.REACT_APP_MIFIRMA_API)
  signerService = new SignerService(this.url)
  userService = new UserService(this.url)
  bovedaService = new BovedaApi(this.url)
  clientService = new ClientService(this.url)
  userDocService = new UserDocService(this.url)
  workflowExecutionId = ''
  signatureRequestId = 0
  timezone = getNavigatorTimezone()
  validator = SignatureRequestValidator(this.props.t)
  userInfo = {}
  baseSign = false
  language = 'es'


  componentDidMount() {
    this.toggleLoadingScreen(true)
    this.token = this.localStorageService.getLocalStorageItem("token").idToken
    this.user = this.localStorageService.getLocalStorageItem("user")
    let preferredLanguage = this.localStorageService.getLocalStorageItem("preferredLanguage")
    let urlArr = window.location.href.split("/")
    this.signatureRequestId = urlArr[urlArr.length - 1]
    this.userInfo =
      this.localStorageService.getLocalStorageItem("user").userMetaData
    //call sockets
    socket.on("messages", (data) => this.addNewMessageSocket(data))
    let language = preferredLanguage || "es"
    this.language = language
    this.getSignatureRequest()
    this.getSignatureTypes()

    let infodevice = navigator.userAgent.toLowerCase()
    let isMobile = infodevice.includes("android")
    isMobile = isMobile || infodevice.includes("iphone")
    isMobile = isMobile || infodevice.includes("ipad")
    isMobile = isMobile || infodevice.includes("mobile")

    this.setState({
      token: this.token,
      user: this.user,
      signatureRequestId: this.signatureRequestId,
      language,
      isMobile
    })
  }

  async componentWillUnmount() {
    socket.emit("leaveRoom", this.workflowExecutionId)
  }

  toggleLoadingScreen = (value) => {
    this.setState({
      isLoadingView: value
    })
  }

  toggleForbiddenRequesting = () => {
    this.setState({
      showErrorRequesting: true,
      isLoadingView: false
    }, () => {
      setTimeout(() => {
        this.setState({
          showErrorRequesting: false,
        })
        this.props.history.push("/")
      }, 4000)
    })
  }

  toggleErrorRequesting = (message, time, sendInbox) => {
    this.setState({
      showErrorRequesting: true,
      messageError: message
    }, () => {
      setTimeout(() => {
        this.setState({
          showErrorRequesting: false,
        })
        if (sendInbox) {
          this.props.history.push("/")
        }
      }, time)
    })
  }

  toggleLoadingRequesting = (value) => {
    this.setState({
      showLoadingRequesting: value,
    })
  }

  toggleCompletedRequesting = (value, time, sendInbox, message) => {
    this.setState({
      showCompletedRequesting: value,
      messageComplete: message
    }, () => {
      setTimeout(() => {
        this.setState({
          showCompletedRequesting: false,
          messageComplete: null
        })
        if (sendInbox) {
          this.props.history.push("/")
        }
      }, time)
    })
  }

  toggleWarningRequesting = (value, time, sendInbox, message) => {
    this.setState({
      showWarningRequesting: value,
      messageWarning: message
    }, () => {
      setTimeout(() => {
        this.setState({
          showWarningRequesting: false,
          messageWarning: null
        })
        if (sendInbox) {
          this.props.history.push("/")
        }
      }, time)
    })
  }

  getSignatureRequest = async () => {
    let errorMessage = 'Ocurrió un error al consultar la solicitud de firma'
    try {
      let signatureResponse = await this.signatureRequestService.getSignatureRequestById(this.signatureRequestId, this.token)
      if (signatureResponse.statusCode === Number(process.env.REACT_APP_STATUS_CODE_NOT_ACCES)) {
        this.setState({ messageError: signatureResponse.message })
        this.toggleForbiddenRequesting()
        return false
      }
      let signatureRequest = signatureResponse.data
      if (!signatureRequest || !signatureRequest.userRequestingSing) {
        this.toggleLoadingScreen(false)
        this.toggleErrorRequesting(true, errorMessage, 4000, true)
        return
      }

      let convertDate = convertToStandarDate(signatureRequest.signRequest.expirationDate, this.language)
      let userRequesting = `${signatureRequest.userRequestingSing.firstName} ${signatureRequest.userRequestingSing.firstLastName} ${signatureRequest.userRequestingSing.secondLastName}`
      let expirationDate = convertDate
      let limitDate60 = signatureRequest.signRequest.limitExpirationDate
      let dateStart = signatureRequest.signRequest.expirationDate
      let limiteDate = limitExpirationDateInContract(limitDate60)
      let dateDialogChangeModal = dateInDialogChanceDate(dateStart)
      let signStatusName = signatureRequest.signRequest.signRequestStatus.name
      let tokenUserName = `${this.user.userMetaData.userA3Cloud.firstName} ${this.user.userMetaData.userA3Cloud.firstLastName} ${this.user.userMetaData.userA3Cloud.secondLastName}`
      let tokenUserNames = `${this.user.userMetaData.userA3Cloud.firstName}`
      let tokenUserLastnames = `${this.user.userMetaData.userA3Cloud.firstLastName} ${this.user.userMetaData.userA3Cloud.secondLastName}`
      let signStatusColor = '#2196F3'
      let isSignRequestPending = false
      let isSignRequestReject = false
      let preferences = await this.clientService.getClientPreferences(this.token, this.timezone)
      let inboxId = signatureRequest.inbox.id
      let dateLimitTypeDate = signatureRequest.signRequest.dateLimitTypeDate

      //Validate signature base
      let signatureBaseCreatedAfterWorkflow = (signatureRequest.userAutographySign && signatureRequest.userAutographySign.status) ? true : false
      let sigantureBaseIsApproved = (signatureBaseCreatedAfterWorkflow && signatureRequest.userAutographySign && signatureRequest.userAutographySign.status && signatureRequest.userAutographySign.status === process.env.REACT_APP_SIGNATURE_BASE_STATUS_APPROVED) ? true : false
      let signatureBaseCanUse = (!signatureBaseCreatedAfterWorkflow || (signatureBaseCreatedAfterWorkflow && sigantureBaseIsApproved)) ? true : false

      if (signatureRequest.autographySign && signatureBaseCanUse) this.baseSign = !!preferences.data.find(preference => preference.preferenceName === process.env.REACT_APP_PREFERENCE_BASE_SIGN && preference.booleanValue)

      if (signatureRequest?.signRequest?.requireSignSupport) {
        try {
          let imgs = await this.userDocSuppService.getUserDocSupps(
            this.token
          )
          let { autographySignImg, ineFrontImg, ineBackImg } = imgs
          if (autographySignImg && ineFrontImg && ineBackImg) {
            this.setState({
              signatureImg: "data:image/png;base64," + autographySignImg,
              ineFrontImg: "data:image/png;base64," + ineFrontImg,
              ineBackImg: "data:image/png;base64," + ineBackImg,
              imgLoading: false,
            })
          } else this.warningUserDontHaveIne(true)
        } catch (error) {
          this.setState({
            imgLoading: false,
          })
          this.warningUserDontHaveIne(true)
        }
      }

      if (
        signatureRequest.signRequest.signRequestStatus.id ===
        Number(process.env.REACT_APP_SIGN_REQUEST_STATUS_PENDING)
      ) {
        // pending
        signStatusColor = '#FF8F00'
        isSignRequestPending = true
      } else if (
        signatureRequest.signRequest.signRequestStatus.id ===
        Number(process.env.REACT_APP_SIGN_REQUEST_STATUS_REJECT)
      ) {
        // reject
        signStatusColor = '#E53935'
        isSignRequestReject = true
      } else if (
        signatureRequest.signRequest.signRequestStatus.id ===
        Number(process.env.REACT_APP_SIGN_REQUEST_STATUS_COMPLET)
      ) {
        // complet
        signStatusColor = '#2196F3'
      } else if (
        signatureRequest.signRequest.signRequestStatus.id ===
        Number(process.env.REACT_APP_SIGN_REQUEST_STATUS_CANCEL)
      ) {
        // Cancel
        signStatusColor = "#E53935"
      }

      let emailUser = `${this.user.userMetaData.userA3Cloud.email}`
      let currentUser = signatureRequest.signersList.find((item) => item.email === emailUser)
      if (!currentUser && signatureRequest && signatureRequest.signRequest && signatureRequest.signRequest.user && signatureRequest.signRequest.user.email && signatureRequest.signRequest.user.email === emailUser) currentUser = signatureRequest.signRequest.user

      let showBtnNotify = signatureRequest.userCanSendNotify
      let userCanEditDate = (signatureRequest.signRequest.signRequestStatus.id === Number(process.env.REACT_APP_SIGN_REQUEST_STATUS_PENDING)) ? signatureRequest.userCanEditExpirationDate : false


      if (currentUser.email === signatureRequest.signRequest.user.email) {
        signatureRequest.signersList
          .filter((signer) => signer.email !== this.user.userMetaData.userMifirma.email)
          .forEach((signer) => {
            signer.notifyBtn = signer.signStatusName === 'pending'
          })
      }
      signatureRequest.signersList.map((signer) => {
        let color = '#FF8F00'
        switch (signer.signStatusName) {
          case 'signed':
            color = '#2196F3'
            break
          case 'rejected':
            color = '#E53935'
            break
          case 'unauthorized':
            color = '#E53935'
            break
          case 'approved':
            color = '#2196F3'
            break
          case 'authorized':
            color = '#2196F3'
            break
          default:
            color = '#FF8F00'
        }

        signer.color = color
        return signer
      })

      let userMultipleSign = false
      const signerFound = signatureRequest.signersList.find(signer => signer.email === this.user.userMetaData.userMifirma.email)
      if (signerFound) {
        userMultipleSign = signerFound.coordinates && signerFound.coordinates.data && signerFound.coordinates.data.length && signerFound.coordinates.data.length > 1
      }

      let documentNameToShowInSign = ''
      let documentPathURL = signatureRequest.documentPath
      let isSignPackage = (signatureRequest.signRequest && signatureRequest.signRequest.documentManageId && signatureRequest.signRequest.documentManageId === Number(process.env.REACT_APP_SIGN_REQUEST_MANAGE_SIGN_PACKAGE_ID)) ? true : false
      let documentsPackage = []
      if (isSignPackage) {
        documentsPackage = (signatureRequest.signRequest && signatureRequest.signRequest.signDocuments && signatureRequest.signRequest.signDocuments.length > 0) ? signatureRequest.signRequest.signDocuments : []
        documentPathURL = (signatureRequest && documentsPackage.length > 0 && documentsPackage[0].documentPathURL) ? documentsPackage[0].documentPathURL : signatureRequest.documentPath
        documentNameToShowInSign = (signatureRequest && documentsPackage.length > 0 && documentsPackage[0].documentName) ? documentsPackage[0].documentName : ''
      }

      let showCancellationReason = (signatureRequest && signatureRequest.signRequest && signatureRequest.signRequest.signRequestStatus && signatureRequest.signRequest.signRequestStatus.id === Number(process.env.REACT_APP_SIGN_REQUEST_STATUS_CANCEL)) ? true : false
      let cancellationReason = (signatureRequest && signatureRequest.signRequest && signatureRequest.signRequest.cancellationReason) ? signatureRequest.signRequest.cancellationReason : ''

      const CANCEL = Number(process.env.REACT_APP_SIGN_REQUEST_STATUS_CANCEL)
      const REJECT = Number(process.env.REACT_APP_SIGN_REQUEST_STATUS_REJECT)
      const currentStatusId = Number(signatureRequest?.signRequest?.signRequestStatus?.id)
      const isCanceledOrRejected = [CANCEL, REJECT].includes(currentStatusId)
      const hasPSC = !!(signatureRequest.servicesInSignsRequest.length > 0)

      const dialogUpdates = {}
      if (isCanceledOrRejected) {
        dialogUpdates.isWarnign = true
        dialogUpdates.titleDialog = this.props.t('detailSignatureView.documentDeletedByCancellation.title.modal')
        dialogUpdates.messageWarning = this.props.t('detailSignatureView.documentDeletedByCancellation')
      }

      let workflowId = 8
      this.getWorkflowContract(workflowId, signatureRequest)
      // this.getBovedaData(signatureRequest)
      this.setState({
        userMultipleSign,
        signatureRequestInfo: signatureRequest,
        signers: signatureRequest.signersList,
        userCanEditExpirationDate: userCanEditDate,
        userCanCancelSignRequest: signatureRequest.userCanCancelSignRequest && this.user.userMetaData.userMifirma.userType.id !== 3,
        signRequestHasAlmostASign: signatureRequest?.signRequest?.signRequestHasAlmostASign,
        expirationDate: expirationDate,
        limitExpirationDate: limiteDate,
        date: dateDialogChangeModal,
        requireSignSupport: signatureRequest.signRequest.requireSignSupport,
        authorizerCanSign: signatureRequest.authorizerCanSign,
        signRequestPDFURL: documentPathURL,
        userCanSign: signatureRequest.userCanSign,
        userRequestingSign: userRequesting,
        signRequestPDF: signatureRequest.documentPDF,
        userCanResendInformation: signatureRequest.userCanResendInformation,
        signRequestIsExpired: signatureRequest.signRequestIsExpired,
        signStatusName,
        signStatusColor,
        isSignRequestPending,
        isSignRequestReject,
        currentUser,
        tokenUserNames,
        tokenUserLastnames,
        currentUserName: tokenUserName,
        showBtnNotify,
        signgRequestIsPackage: isSignPackage,
        documentsPackage,
        inboxId,
        documentNameToShowInSign,
        showCancellationReason,
        cancellationReason,
        dateLimitTypeDate,
        ...dialogUpdates,
        includesMessageCertificate: hasPSC
      })
    } catch (error) {
      this.toggleLoadingScreen(false)
      this.toggleErrorRequesting(true, errorMessage, 4000, true)
    }
  }

  getSignatureTypes = async () => {
    let errorMessage = 'Ocurrió un error al consultar los tipos de firma que existen'
    try {
      let signatureTypes = await this.signatureTypesService.getSignatureTypes(this.token)
      this.setState({
        signatureTypes
      })
    } catch (error) {
      this.toggleLoadingScreen(false)
      this.toggleErrorRequesting(true, errorMessage, 4000, true)
    }
  }

  toggleEditExpirationDate = () => {
    this.setState({ visibleExpirationDate: !this.state.visibleExpirationDate })
  }

  onUpdateExpirationDate = async (dataItem) => {
    let messageError = 'Ocurrió un error al actualizar la fecha'
    if (!dataItem || !dataItem.expirationDate) {
      let messageErrorDate = 'Selecciona una fecha'
      this.toggleErrorRequesting(messageErrorDate, 4000, false)
      return
    }
    moment.locale("es")
    try {
      this.toggleLoadingRequesting(true)
      let { expirationDate } = dataItem
      let { id } = this.state.signatureRequestInfo.signRequest
      let newExpirationDate =
        await this.signatureRequestService.updateSignRequestExpirationDate(
          id,
          expirationDate,
          this.token
        )
      if (
        Number(newExpirationDate.statusCode) !== 200 ||
        !newExpirationDate.data
      ) {
        throw new Error("No se puedo actualizar la fecha de expiración")
      }

      let newDate = StandardDates.fromISODate(newExpirationDate.data.newExpirationDate.expirationDate).toFormat('dd/MMM/yyyy').toLowerCase()
      this.setState({ expirationDate: newDate })

      this.toggleLoadingRequesting(false)
      this.toggleEditExpirationDate()
      this.toggleCompletedRequesting(true, 4000, false)
      return true
    } catch (error) {
      this.toggleLoadingRequesting(false)
      this.toggleErrorRequesting(messageError, 4000, false)
      return false
    }
  }

  warningUserDontHaveIne = (isWarnign = false) => {
    let data = {
      message: `${this.props.t(
        "signatureRequestDetailAction2.errorINEOrAuthorizerSignatureNotFound"
      )}`,
    }
    if (isWarnign) {
      data.isWarnign = isWarnign
    } else data.showErrorRequesting = true
    this.setState(data)
  }

  notifyClient = async (dataItem) => {
    this.toggleLoadingRequesting(true)
    let { signRequestId, email } = dataItem
    await this.notifService.resendNotification(signRequestId, email, this.token)
    this.toggleLoadingRequesting(false)
    this.toggleCompletedRequesting(true, 4000, false)
  }

  /**
   * @author Lucia Alvarado
   * @description Handle the submit event to reject sign
   * @param {Event} event
   * @memberof SignatureRequestDetailAction
   */
  onSubmitReject = async (dataItem) => {
    let messageError = 'Ocurrió un error al rechazar la solicitud'
    try {
      this.clearErrors()
      this.cancel()
      // 2.- Peticion POST para rechazar solicitud de firma /signer-reject-sign
      if (dataItem.comments.trim() <= 0) {
        this.setState({ errorTextArea: true })
        return false
      } else {
        this.setState({ errorTextArea: false, visibleReject: false })
        this.clearErrors()
        this.cancel()
        this.toggleLoadingRequesting(true)
        let signRequestId = this.state.signatureRequestInfo.signRequest.id
        let signStatusId = this.state.signatureRequestInfo.signRequest.signRequestStatus.id
        let comments = dataItem.comments
        let signReject = await this.signerService.createRejectSign(signRequestId, signStatusId, comments, this.token)
        if (signReject.statusCode === 200) {
          this.setState({ showNotification: true, showLoadingRequesting: false })
          this.toggleCompletedRequesting(true, 4000, true)
        } else if (signReject.statusCode === -1) {
          this.setState({ showNotification: true, showLoadingRequesting: false })
          this.toggleErrorRequesting(messageError, 4000, false)
          this.setState({ showNotification: true })
        }
      }
    } catch (error) {
      this.toggleLoadingRequesting(false)
      this.toggleErrorRequesting(messageError, 4000, false)
      return false
    }
  }

  /**
  * @author Alan Aguilar
  * @description Method for delete the error from the state
  * @param {Event} event
  * @memberof SignatureRequestDetailAction
  */
  clearErrors = () => {
    this.setState({
      errorFileKey: false,
      errorFileCer: false,
      errorPassword: false,
      errorTextArea: false,
    })
  }

  /**
  * @author Lucia Alvarado
  * @description Show dialog reject
  * @param {Object} dataItem
  * @memberof SignatureRequestDetailAction
  */
  toggleDialogReject = () => {
    let visible = this.state.visibleReject
    this.setState({
      visibleReject: !visible,
      visibleAccept: false,
    })
  }

  /**
  * @author Lucia Alvarado
  * @description Method to clear and hide dialog
  * @memberof SignatureRequestAction
  */
  cancel = () => {
    this.setState({
      disableUserButton: true,
      errorTextArea: false,
    })
    this.clearErrors()
  }

  /**
  * @author Leonel Contreras
  * @description Close/Open the modal
  */
  onCloseOpenModal = () =>
    this.setState({ showNotification: !this.state.showNotification })

  handleWarning = () => this.setState({ isWarnign: !this.state.isWarnign })

  handleWarningClose = () => {
    this.setState({ isWarnign: false })
  }

  handleWarningReturnInbox = () => {
    this.setState({ isWarnign: false }, () => {
      this.props.history.push('/')
    });
  }

  setPassword = (passwordKey) => this.setState({ passwordKey })
  setIsShowAutorizationModal = () =>
    this.setState({
      isShowAutorizationModal: !this.state.isShowAutorizationModal,
    })


  /**
  * @author Lucia Alvarado
  * @description Handle the submit event to accept sign
  * @updatedDate 01-04-2022
  * @param {Event} event
  * @memberof SignatureRequestDetailAction
  */
  onSubmit = async (nip, setNip, stampTime, bufferVideo, bufferImage) => {
    try {
      let signatureType = this.state.signatureRequestInfo.signRequest.signatureTypeId
      if (!this.user.userMetaData.userA3Cloud.rfc &&
        (signatureType === +process.env.REACT_APP_SIGNATURE_TYPE_E_FIRMA
          ||
          signatureType === +process.env.REACT_APP_SIGNATURE_TYPE_ELECTRONICA
        )) {

        this.toggleLoadingRequesting(false)
        this.toggleErrorRequesting("Aun no se ha ingresado el RFC, te redireccionaremos hacia tu perfil", 3000)
        setTimeout(() => {
          this.props.history.push("/profile")
        }, 3000)
        return
      }

      this.toggleLoadingRequesting(true)
      this.clearErrors()
      this.setState({ visibleAccept: false })

      if (this.state.userCanSign === false) return false
      if (this.state.errorFileKey === true || this.state.errorFileCer === true)
        return false

      if (this.baseSign && this.state.allSignatures.find((i) => !!i.fileSignImage)) {
        let newNip = await this.userDocService.verifyNip(nip, this.token)
        if (newNip.isEqual === false) {
          setNip("")
          this.setState({
            message: this.props.t(`signatureRequestDetailAction2.errorNip`),
          })
          this.toggleLoadingRequesting(false)
          this.toggleErrorRequesting(this.props.t(`signatureRequestDetailAction2.errorNip`), 3000)
          return false
        }
      }

      // 1.- Peticion POST para aceptar la solicitud de firma /signer-confirm-sign
      let signRequestDocumentData = new FormData()
      signRequestDocumentData.append(
        "signRequestId",
        this.state.signatureRequestInfo.signRequest.id
      )
      signRequestDocumentData.append(
        "signatureTypeId",
        this.state.signatureRequestInfo.signRequest.signatureTypeId
      )
      signRequestDocumentData.append("signatureStampTime", stampTime)

      if (this.state.currentUser.proofOfLife) {
        signRequestDocumentData.append("bufferVideo", bufferVideo)
        signRequestDocumentData.append("bufferImage", bufferImage)
      }

      if (!!this.state.allSignatures.find((i) => !!i.fileSignImage)) {
        signRequestDocumentData.append(
          "signatures",
          JSON.stringify(
            this.state.allSignatures.map((i) => ({
              x: i.x,
              y: i.heightImg - i.y - 100,
              width: i.width,
              height: i.height,
              page: i.page,
              isMobile: !!i.isMobile,
              fileName: i.fileName,
            }))
          )
        )
        this.state.allSignatures.forEach((i) => {
          signRequestDocumentData.append(i.fileName, i.fileSignImage)
        })
      }
      else {
        if (this.state.passwordKey)
          signRequestDocumentData.append("passwordKey", this.state.passwordKey)
        if (this.state.passwordReliable)
          signRequestDocumentData.append(
            "passwordReliable",
            this.state.passwordReliable
          )

        signRequestDocumentData.append("fileKEY", this.state.selectedFileKey)
        signRequestDocumentData.append("fileCER", this.state.selectedFileCer)
      }

      let updateSignData = {
        inboxId: this.state.inboxId,
        showInbox: false
      }
      const signDocumentPackage = await this.signerService.signerSignRequest(
        signRequestDocumentData,
        this.token
      )

      let messageError = this.props.t("detailSignatureAction.errors.submit.general")
      if (signDocumentPackage && signDocumentPackage.statusCode === 200) {
        this.toggleLoadingRequesting(false)
        this.setState({ showNotification: true })
        this.toggleCompletedRequesting(true, 6000, true, this.props.t("uploadIdentityDocument.submit.successfully"))
      } else if (signDocumentPackage.statusCode === 410 && (signDocumentPackage.data && signDocumentPackage.data.signing)) {
        this.toggleLoadingRequesting(false)
        this.setState({ showNotification: true })
        this.toggleWarningRequesting(true, 6000, false, `${this.props.t(
          "signRequestDetail.isSigningPt1"
        )} ${signDocumentPackage.data.emailSigner} ${this.props.t(
          "signRequestDetail.isSigningPt2"
        )}`)
        return
      } else if (signDocumentPackage && signDocumentPackage.statusCode === 420) {
        messageError = this.props.t("detailSignatureAction.errors.signer.info.not")
        this.toggleLoadingRequesting(false)
        this.setState({ showNotification: true })
        this.toggleErrorRequesting(messageError, 4000, false)
      } else if (signDocumentPackage && signDocumentPackage.statusCode === 425) {
        messageError = this.props.t("detailSignatureAction.errors.signer.not.fda")
        this.toggleLoadingRequesting(false)
        this.setState({ showNotification: true })
        this.toggleErrorRequesting(messageError, 4000, false)
      } else if (signDocumentPackage && (signDocumentPackage.statusCode === 450 || signDocumentPackage.statusCode === 452)) {
        messageError = this.props.t("uploadIdentityDocument.errors.user.name.not.match")
        this.toggleLoadingRequesting(false)
        this.setState({ showNotification: true })
        this.toggleErrorRequesting(messageError, 4000, false)
      } else {
        this.toggleLoadingRequesting(false)
        this.toggleErrorRequesting(messageError, 4000, false)
        return false
      }
    } catch (error) {
      let messageError = `${this.props.t(
        "signatureRequestDetailAction2.errorDefaultSignerConfirm"
      )}`
      this.toggleLoadingRequesting(false)
      this.toggleErrorRequesting(messageError, 4000, false)
      return false
    }
  }

  /**
  * @author Lucia Alvarado
  * @description Show dialog confirm
  * @param {Object} dataItem
  * @memberof SignatureRequestDetailAction
  */
  toggleDialogAccept = () => {
    this.setState({
      visibleAccept: !this.state.visibleAccept,
      visibleReject: false,
    })
  }


  /**
  * @author Alan Aguilar
  * @description Method Delete the ConfirmationSign dato from the state
  * @param {Event} event
  * @memberof SignatureRequestDetailAction
  */
  onDeleteDataAccept = () => {
    this.setState({
      visibleAccept: false,
      dataItem: {},
      selectedFileKey: null,
      selectedFileCer: null,
    })
    this.clearErrors()
  }


  // getBovedaData = async (signatureRequest) => {
  //   let messageError = 'Ocurrió un error al consultar la información desde el módulo de Bóveda'
  //   let emailUser = `${this.user.userMetaData.userA3Cloud.email}`
  //   let responseUploaded

  //   try {
  //     const canUploadDocument = await this.userService.getRolesForUserByEmail(this.token, emailUser)
  //     if (canUploadDocument.data.roleBoveda && canUploadDocument.data.roleBoveda.key && canUploadDocument.data.roleBoveda.key !== "roleHibouDigitalVaultNotAccess") {
  //       responseUploaded = await this.bovedaService.getBovedaDocument(signatureRequest.signRequest.id, this.token)
  //       this.setState({
  //         idVault: canUploadDocument.data.roleBoveda.id
  //       })
  //     } else {
  //       this.toggleLoadingScreen(false)
  //       return
  //     }

  //     if (
  //       responseUploaded &&
  //       responseUploaded.idPrecarga &&
  //       (canUploadDocument.data.roleBoveda.id === 14 ||
  //         canUploadDocument.data.roleBoveda.id === 15)
  //     ) {
  //       this.setState({
  //         idPrecharge: responseUploaded.idPrecarga,
  //         idVault: canUploadDocument.data.roleBoveda?.id,
  //       })
  //     } else if (responseUploaded && responseUploaded.code === -3) {
  //       this.setState({
  //         idPrecharge: undefined,
  //       })
  //     }
  //     this.toggleLoadingScreen(false)
  //   } catch (error) {
  //     this.toggleLoadingScreen(false)
  //     this.toggleErrorRequesting(true, messageError, 4000, true)
  //   }
  // }

  // sendToDigitalVault = async (signRequestId) => {
  //   this.toggleLoadingRequesting(true)
  //   let messageError = 'Ocurrió un error al enviar el documento a Bóveda'
  //   try {
  //     let response = await this.bovedaService.uploadBovedaDocument(signRequestId, this.token
  //     )
  //     if (response && response.code === 200) {
  //       this.setState({
  //         idPrecharge: response.idPrecarga,
  //       })
  //       this.toggleLoadingRequesting(false)
  //       this.toggleCompletedRequesting(true, 4000, true)
  //     } else {
  //       this.toggleLoadingRequesting(false)
  //       this.toggleErrorRequesting(messageError, 4000, false)
  //     }
  //   } catch (error) {
  //     this.toggleLoadingRequesting(false)
  //     this.toggleErrorRequesting(messageError, 4000, false)
  //   }
  // }

  /**
  * @author Alan Aguilar
  * @description Method to show the resend signature request dialog
  * @updatedDate 03-06-2021
  * @memberof SignatureRequestAction
  */
  toggleDialogResendSignatureRequest = () => {
    this.setState({
      visibleDialogResendSignatureRequest:
        !this.state.visibleDialogResendSignatureRequest,
    })
  }

  /**
  * @author Alan Aguilar
  * @description Call service to resend the information of the sign request completed
  * @updatedDate 03-06-2021
  * @memberof SignatureRequestAction
  */
  onResendSignatureRequest = async () => {
    let messageError = 'Ocurrió un error al reenviar la información'
    try {
      this.toggleLoadingRequesting(true)
      let result =
        await this.signatureRequestService.resendSignRequestInformation(
          this.state.signatureRequestInfo.signRequest.id,
          this.token
        )
      if (result && result.statusCode === 200) {
        this.toggleLoadingRequesting(false)
        this.setState({ visibleDialogResendSignatureRequest: false })
        this.toggleCompletedRequesting(true, 4000, false)
      } else {
        this.toggleLoadingRequesting(false)
        this.toggleErrorRequesting(messageError, 4000, false)
      }
    } catch (error) {
      this.toggleLoadingRequesting(false)
      this.toggleErrorRequesting(messageError, 4000, false)
    }
  }


  /**
  * @author Alan Aguilar
  * @description Method to show the reactivation signature request dialog
  * @updatedDate 03-06-2021
  * @memberof SignatureRequestAction
  */
  toggleDialogReactivateSignatureRequest = () => {
    this.setState({
      visibleDialogReactivateSignatureRequest:
        !this.state.visibleDialogReactivateSignatureRequest,
    })
  }


  /**
  * @author Alan Aguilar
  * @description Call service to reactivate a the sign request when rejected
  * @updatedDate 03-06-2021
  * @memberof SignatureRequestAction
  */
  onReactivateSignatureRequest = async () => {
    let messageError = 'Ocurrió un error al reactivar la solicitud de firma'
    try {
      this.toggleLoadingRequesting(true)
      let result = await this.signatureRequestService.reactivationSignRequestRejected(this.state.signatureRequestInfo.signRequest.id, this.token)
      if (result && result.statusCode === 200) {
        this.toggleLoadingRequesting(false)
        this.setState({ visibleDialogReactivateSignatureRequest: false })
        this.toggleCompletedRequesting(true, 4000, true)
      } else {
        this.toggleLoadingRequesting(false)
        this.toggleErrorRequesting(messageError, 4000, false)
      }
    } catch (error) {
      this.toggleLoadingRequesting(false)
      this.toggleErrorRequesting(messageError, 4000, false)
    }
  }

  /**
  * @author Alan Aguilar
  * @description Method to get the file
  * @param {Event} event
  * @memberof SignatureRequestDetailAction
  */
  handleFileCer = (e) => {
    if (e.target.files.length > 0) {
      let filename = e.target.files[0].name
      let filenameArray = filename.split(".")
      let extension = filenameArray[filenameArray.length - 1]

      if (extension === "cer" || extension === "pem") {
        this.setState({
          selectedFileCer: e.target.files[0],
          errorFileCer: false,
          selectedFileCerName: filename,
        })
      } else {
        this.setState({
          selectedFileCer: null,
          errorFileCer: true,
          selectedFileCerName: `${this.props.t(
            "signatureRequestDetailAction2.noUploadFile"
          )}`,
        })
        return false
      }
    } else {
      return false
    }
  }

  /**
  * @author Alan Aguilar
  * @description Handler method for capture the information in all inputs
  * @date 15-12-2020
  * @param {Object} e
  * @memberof AuthService
  */
  onHandleGeneralChange = (e) => {
    this.setState({
      ...this.state,
      [e.target.id]: e.target.value,
    })
  }

  /**
  * @author Alan Aguilar
  * @description Method to get the file
  * @param {Event} event
  * @memberof SignatureRequestDetailAction
  */
  handleFileKey = (e) => {
    if (e.target.files.length > 0) {
      let filename = e.target.files[0].name
      let filenameArray = filename.split(".")
      let extension = filenameArray[filenameArray.length - 1]

      if (extension === "key" || extension === "pem") {
        this.setState({
          selectedFileKey: e.target.files[0],
          errorFileKey: false,
          selectedFileKeyName: filename,
        })
      } else {
        this.setState({
          selectedFileKey: null,
          errorFileKey: true,
          selectedFileKeyName: `${this.props.t(
            "signatureRequestDetailAction2.noUploadFile"
          )}`,
        })
        return false
      }
    } else {
      return false
    }
  }

  getWorkflowContract = async (workflowId, signatureRequest) => {
    let errorMessage = 'Ocurrió un error al consultar la información dedl workflow'
    let solicitudeId = this.signatureRequestId
    let ENV = process.env

    try {
      let workflow = await this.workflowService.getWorkflowBySolicitudeIdAndWorkflowId(solicitudeId, workflowId, this.token)
      if (workflow && workflow.data && Number(workflow.statusCode) === 200) {
        this.workflowExecutionId = workflow.data.id
        socket.emit("joinRoom", this.workflowExecutionId)
        this.getMessages(workflow.data)
        this.toggleLoadingScreen(false)

        let titleHeader = (workflow.data.allStatus && workflow.data.allStatus.workflowStatusCurrent && workflow.data.allStatus.workflowStatusCurrent.name) ? workflow.data.allStatus.workflowStatusCurrent.name : ''
        let workflowStatusCurrent = (workflow && workflow.data && workflow.data.workflowStatusCurrent) ? workflow.data.workflowStatusCurrent : 0
        let statusCancel = (workflow && workflow.data && workflow.data.allStatus && workflow.data.allStatus.workflowStatusCurrent && workflow.data.allStatus.workflowStatusCurrent.cancelStatus > 0) ? workflow.data.allStatus.workflowStatusCurrent.cancelStatus : 0
        let showBtnNext = ((workflowStatusCurrent === +process.env.REACT_APP_WORKFLOW_SIGN_REQUEST_STATUS_200205 && signatureRequest.authorizerCanSign) || (workflowStatusCurrent === +process.env.REACT_APP_WORKFLOW_SIGN_REQUEST_STATUS_200210 && signatureRequest.userCanSign) && signatureRequest.signRequest.signRequestStatus.id === Number(process.env.REACT_APP_SIGN_REQUEST_STATUS_PENDING)) ? true : false
        let showBtnReject = (statusCancel > 0 && (signatureRequest.userCanSign === true || signatureRequest.authorizerCanSign === true) && signatureRequest.signRequest.signRequestStatus.id === Number(process.env.REACT_APP_SIGN_REQUEST_STATUS_PENDING)) ? true : false
        let labelBtnNext = (workflow.data.allStatus && workflow.data.allStatus.workflowStatusCurrent && workflow.data.allStatus.workflowStatusCurrent.nextButtonLabel) ? workflow.data.allStatus.workflowStatusCurrent.nextButtonLabel : ''
        let labelBtnReject = (workflow.data.allStatus && workflow.data.allStatus.workflowStatusCurrent && workflow.data.allStatus.workflowStatusCurrent.cancelButtonLabel) ? workflow.data.allStatus.workflowStatusCurrent.cancelButtonLabel : ''

        if (workflowStatusCurrent === +process.env.REACT_APP_WORKFLOW_SIGN_REQUEST_STATUS_200215) {
          showBtnReject = false
        }

        if (workflowStatusCurrent === +process.env.REACT_APP_WORKFLOW_SIGN_REQUEST_STATUS_200215 && signatureRequest.userCanSign) {
          showBtnNext = true
        }

        let currentUser = this.state.currentUser
        if (workflowStatusCurrent === +process.env.REACT_APP_WORKFLOW_SIGN_REQUEST_STATUS_200205) {
          currentUser = signatureRequest.signersList.find(signer => signer.email === currentUser.email && signer.signerType.id === Number(ENV.REACT_APP_SIGNERS_TYPE_VALIDATOR))
        } else {
          currentUser = signatureRequest.signersList.find(signer => signer.email === currentUser.email && signer.signerType.id !== Number(ENV.REACT_APP_SIGNERS_TYPE_VALIDATOR))
        }

        const getNextButton = (str) => {
          let label
          let image

          switch (str) {
            case 'Firmar':
              label = 'detailSignatureView.btn.sign'
              image = `${process.env.REACT_APP_AWS_S3_BUCKET_URL}${process.env.REACT_APP_ICONS_BOVEDA_DIGITAL_SIGN_REQUEST}`
              break
            case 'Autorizar':
              label = 'detailSignatureView.btn.authorize'
              image = `${process.env.REACT_APP_AWS_S3_BUCKET_URL}${process.env.REACT_APP_ICONS_SIGN_REQUEST_AUTHORIZE}`
              break
            case 'Enviar':
              label = 'uploadIdentityDocument.btn.send'
              break
            default:
              break
          }
          return [label, image]
        }

        this.setState({
          workflowContract: workflow.data,
          titleHeader,
          workflowStatusCurrent,
          showBtnNext,
          showBtnReject,
          labelBtnNext: getNextButton(labelBtnNext)[0],
          labelBtnReject: 'detailSignatureView.btn.reject',
          nextImage: getNextButton(labelBtnNext)[1],
          currentUser
        })
      } else {
        this.toggleErrorRequesting(true, errorMessage, 4000, true)
        this.toggleLoadingScreen(false)
      }
    } catch (error) {
      this.toggleErrorRequesting(true, errorMessage, 4000, true)
      this.toggleLoadingScreen(false)
    }
  }

  getMessages = async (workflow) => {
    let errorMessage = "Ocurrió un error al consultar los mensajes"
    let workflowExecutionId = workflow.id
    let user = {}
    try {
      //Get message and members chat
      let workflowMessage =
        await this.workflowMessagesService.getWorkFlowExecutionMessage(
          workflowExecutionId,
          this.timezone,
          this.token
        )
      if (
        workflowMessage &&
        workflowMessage.data &&
        Number(workflowMessage.statusCode) === 200
      ) {
        //Filter out duplicated members
        let membersChat = workflowMessage.data.workflowExecutionMembers.filter((member, index) =>
          workflowMessage.data.workflowExecutionMembers.findIndex((item) => item.email === member.email) === index
        )
        //users chat
        membersChat.map((member) => {
          member.id = member.workflowExecutionMemberId
          member.avatarUrl = member.profilePicture
          member.name = member.firstName + " " + member.firstLastName
          member.avatarAltText = member.firstName + " " + member.firstLastName
          if (this.user.userMetaData.userA3Cloud.email === member.email) {
            this.idAuthorMessage = member.id
            user = member
          }
          return membersChat
        })

        //Message chat
        workflowMessage.data.workflowExecutionMessages.map((member) => {
          member.author = {
            name: member.firstName + " " + member.firstLastName,
            id: member.workflowExecutionMemberId,
            avatarUrl: member.profilePicture,
          }
          let dateConvert = new Date(member.createdDate)
          member.timestamp = dateConvert
          member.text = member.workflowExecutionMemberMessage
          member.id = member.workflowExecutionMemberId
          member.name = member.firstName + " " + member.firstLastName
          member.avatarUrl = member.profilePicture
          if (member.workflowExecutionMemberMessageDoc.length > 0) {
            member.attachments = [
              {
                name: member.workflowExecutionMemberMessageDoc[0]?.documentName,
                site: member.workflowExecutionMemberMessageDoc[0]?.documentPath,
              },
            ]
          }
          return workflowMessage.data.workflowExecutionMessages
        })
        this.setState({
          membersChat: membersChat,
          conversation: workflowMessage.data.workflowExecutionMessages,
          usersChat: user,
        })
        this.toggleLoadingRequesting(false)
      } else {
        this.toggleLoadingScreen(false)
        this.toggleErrorRequesting(true, errorMessage, 4000, true)
      }
    } catch (error) {
      this.toggleLoadingScreen(false)
      this.toggleErrorRequesting(true, errorMessage, 4000, true)
    }
  }

  //Function to create message
  createMessage = async (messagesChat, fileContent) => {
    let data = new FormData()
    data.append("workflowExecutionId", this.workflowExecutionId)
    data.append("workflowExecutionMemberId", this.idAuthorMessage)
    data.append("message", messagesChat.text)
    data.append("documento", fileContent)
    data.append("timezone", this.timezone)

    await this.workflowMessagesService.createWorkflowExecutionNewMessage(
      data,
      this.token
    )
  }

  //add a new meessage to conversation when sockets send a mew message
  addNewMessageSocket = (message) => {
    let copyConversation = [...this.state.conversation]
    let indexMessage = copyConversation.length

    let newMessage = {
      author: {
        name: `${message.firstName} ${message.firstLastName}`,
        id: Number(message.workflowExecutionMemberId),
        avatarUrl: message.profilePicture,
      },
      timestamp: message.workflowExcecutionMemberMessage
        ? new Date(message.workflowExcecutionMemberMessage.createdDate)
        : new Date(
          message.workflowExecutionMemberMessageDocName[0].createdDate
        ),
      text: message.workflowExcecutionMemberMessage.message,
      id: Number(message.workflowExecutionMemberId),
      name: `${message.firstName} ${message.firstLastName}`,
      avatarUrl: message.profilePicture,
      workflowExecutionMemberId: Number(message.workflowExecutionMemberId),
      workflowExecutionMemberMessage:
        message.workflowExcecutionMemberMessage.message === "" ||
          message.workflowExcecutionMemberMessage.message === "undefined"
          ? null
          : message.workflowExcecutionMemberMessage.message,

      email: message.email,
      firstName: message.firstName,
      firstLastName: message.firstLastName,
      profilePicture: message.profilePicture,
      selectionIndex: indexMessage,
    }
    if (message.workflowExecutionMemberMessageDocName.length > 0) {
      newMessage.workflowExecutionMemberMessageDoc = [
        {
          name: message.workflowExecutionMemberMessageDocName
            ? message.workflowExecutionMemberMessageDocName[0]
              .workflowExecutionMemberMessageDocName
            : "",
          site: message.workflowExecutionMemberMessageDocName
            ? message.workflowExecutionMemberMessageDocName[0]
              .workflowExecutionMemberMessageDocURL
            : "",
        },
      ]
      newMessage.attachments = [
        {
          name: message.workflowExecutionMemberMessageDocName
            ? message.workflowExecutionMemberMessageDocName[0]
              .workflowExecutionMemberMessageDocName
            : "",
          site: message.workflowExecutionMemberMessageDocName
            ? message.workflowExecutionMemberMessageDocName[0]
              .workflowExecutionMemberMessageDocURL
            : "",
        },
      ]
    }

    copyConversation.push(newMessage)
    this.setState({
      conversation: copyConversation,
    })
  }

  toggleDialogDeleteRequest = () => {
    this.setState({
      visibleDialogDeleteRequest: !this.state.visibleDialogDeleteRequest,
    })
  }

  handleCommentsDelete = async (event) => {
    this.setState({
      commentsDelete: event.target.value,
    })
  }

  deleteSignRequest = async () => {
    let commentsDelete = this.state.commentsDelete
    let signRequest = this.state.signatureRequestInfo.signRequest
    let statusCode = 0

    try {
      await this.toggleLoadingRequesting(true)
      let signRequestDetele =
        await this.signatureRequestService.deleteSignRequestsById(
          signRequest.id,
          commentsDelete,
          this.token
        )
      if (signRequestDetele.statusCode !== 200) {
        statusCode = signRequestDetele.statusCode
        throw new Error()
      }

      this.setState({ visibleDialogDeleteRequest: false })
      await this.toggleLoadingRequesting(false)
      await this.toggleCompletedRequesting(true, true)
      return true
    } catch (error) {
      let message = ''
      switch (statusCode) {
        case -2:
          message = this.props.t(
            "signatureRequestDetailAction2.errorMessageOnlyUserSenderCanDelete"
          )
          break
        case -3:
          message = this.props.t(
            "signatureRequestDetailAction2.errorMessageOnlyDeleteWithAlmostOneSign"
          )
          break
        default:
          message = this.props.t(
            "signatureRequestDetailAction2.errorMessageDefault"
          )
          break
      }
      this.setState({ visibleDialogDeleteRequest: false })
      await this.toggleLoadingRequesting(false)
      await this.toggleErrorRequesting(message, 4000, false)
      return false
    }
  }

  scrollWindow = () => {
    window.scrollTo(0, 0)
  }

  validateNip = async (nip, setNip) => {
    let validatedNip
    if (this.baseSign && !this.state.currentUser.proofOfLife) {
      try {
        let nipValidated = await this.userDocService.verifyNip(nip, this.token)
        if (nipValidated.isEqual === false) {
          validatedNip = nipValidated.isEqual
          setNip("")
          await this.toggleLoadingRequesting(false)
          await this.toggleErrorRequesting(this.props.t(`signatureRequestDetailAction2.errorNip`), 4000, false)
        } else {
          validatedNip = true
        }
      } catch (e) {
        setNip("")
        validatedNip = false
        this.toggleLoadingRequesting(false)
        this.toggleErrorRequesting(this.props.t(`signatureRequestDetailAction2.errorNip`), 4000, false)
      }
    }
    return validatedNip
  }


  authorize = async () => {
    let messageError = 'Ocurrió un error al autorizar la solicitud'
    try {
      this.setIsShowAutorizationModal()
      await this.toggleLoadingRequesting(true)
      let authorizeData = new FormData()
      authorizeData.append(
        "hash",
        hash({ hash: Math.random().toString(36).substring(7) })
      )
      authorizeData.append("signRequestId", this.state.signatureRequestInfo.signRequest.id)
      authorizeData.append(
        "signatureTypeId",
        this.state.signatureRequestInfo.signRequest.signatureTypeId
      )
      let signConfirm = await this.signerService.signerAuthorizes(
        authorizeData,
        this.token
      )
      if (signConfirm.statusCode === 200) {
        this.toggleLoadingRequesting(false)
        this.setState({ showNotification: true })
        this.toggleCompletedRequesting(true, 6000, true, 'Tu autorización está en proceso, por lo que una vez que concluya, se te hará llegar un correo informándote el resultado.')
        this.setState({ showNotification: true })
      } else {
        await this.toggleLoadingRequesting(false)
        await this.toggleErrorRequesting(messageError, 4000, false)
        return false
      }
    } catch (error) {
      await this.toggleLoadingRequesting(false)
      await this.toggleErrorRequesting(messageError, 4000, false)
      return false
    }
  }

  handleSubmit = () => {
    switch (this.state.workflowStatusCurrent) {
      case +process.env.REACT_APP_WORKFLOW_SIGN_REQUEST_STATUS_200205:
        this.setIsShowAutorizationModal()
        break
      case +process.env.REACT_APP_WORKFLOW_SIGN_REQUEST_STATUS_200210:
        if (this.state.isMobile && !this.state.currentUser.proofOfLife) this.setStep("sign")
        else if (this.state.currentUser.proofOfLife) this.setStep("instructions")
        this.toggleDialogAccept()
        break

      default:
        break
    }
  }

  setStep = (step) => {
    this.setState({
      step
    })
  }

  handleReject = () => {
    switch (this.state.workflowStatusCurrent) {
      case +process.env.REACT_APP_WORKFLOW_SIGN_REQUEST_STATUS_200205:
        this.toggleDialogReject()
        break
      case +process.env.REACT_APP_WORKFLOW_SIGN_REQUEST_STATUS_200210:
        this.toggleDialogReject()
        break

      default:
        break
    }
  }

  assignStampVolume = (stamp) => {
    this.setState({ stampVolume: stamp })
  }

  setSignatureImgeData = (signatureImgeData) => {
    if (this.state.signatureRequestInfo && this.state.signatureRequestInfo.signRequest && this.state.signatureRequestInfo.signRequest.signRequestByVolumeId) {
      this.setState({ signatureImgeData }, () => this.onSubmit("", "", this.state.stampVolume))
    } else {
      this.setState({ signatureImgeData }, () => this.onSubmit())
    }
  }

  render() {
    if ((this.state.currentUser && this.state.currentUser.proofOfLife) || (this.state.currentUser && !this.state.currentUser.signatureBaseValid)) this.baseSign = false
    if (this.state.workflowStatusCurrent === +process.env.REACT_APP_WORKFLOW_SIGN_REQUEST_STATUS_200215 && this.state.userCanSign) {
      return (
        <UploadIdentityDocumentAction
          {...this.props}
          {...this.state}

          getSignatureRequest={this.getSignatureRequest}
          handleReject={this.handleReject}
        />
      )
    } else {
      return (
        <DetailSignatureView
          {...this.state}
          baseSign={this.baseSign}
          toggleErrorRequesting={this.toggleErrorRequesting}
          toggleLoadingRequesting={this.toggleLoadingRequesting}
          toggleCompletedRequesting={this.toggleCompletedRequesting}
          toggleWarningRequesting={this.toggleWarningRequesting}
          toggleLoadingScreen={this.toggleLoadingScreen}
          createMessage={this.createMessage}
          toggleEditExpirationDate={this.toggleEditExpirationDate}
          validator={this.validator}
          onUpdateExpirationDate={this.onUpdateExpirationDate}
          notifyClient={this.notifyClient}
          toggleDialogReject={this.toggleDialogReject}
          onSubmitReject={this.onSubmitReject}
          setIsShowAutorizationModal={this.setIsShowAutorizationModal}
          setImgSignature={(params) => this.setState(params)}
          setSignatures={(signatures) => this.setState({ allSignatures: signatures })}
          onSubmit={this.onSubmit}
          toggleDialogAccept={this.toggleDialogAccept}
          onDeleteDataAccept={this.onDeleteDataAccept}
          setSignatureImgeData={this.setSignatureImgeData}
          // sendToDigitalVault={this.sendToDigitalVault}
          toggleDialogResendSignatureRequest={this.toggleDialogResendSignatureRequest}
          onResendSignatureRequest={this.onResendSignatureRequest}
          toggleDialogReactivateSignatureRequest={this.toggleDialogReactivateSignatureRequest}
          onReactivateSignatureRequest={this.onReactivateSignatureRequest}
          handleFileCer={this.handleFileCer}
          onHandleGeneralChange={this.onHandleGeneralChange}
          handleFileKey={this.handleFileKey}
          setPassword={this.setPassword}
          toggleDialogDeleteRequest={this.toggleDialogDeleteRequest}
          deleteSignRequest={this.deleteSignRequest}
          handleCommentsDelete={this.handleCommentsDelete}
          scrollWindow={this.scrollWindow}
          validateNip={this.validateNip}
          authorize={this.authorize}
          handleSubmit={this.handleSubmit}
          setStep={this.setStep}
          handleReject={this.handleReject}
          assignStampVolume={this.assignStampVolume}
          handleWarning={this.handleWarning}
          isCanceledOrRejected={[Number(process.env.REACT_APP_SIGN_REQUEST_STATUS_CANCEL), Number(process.env.REACT_APP_SIGN_REQUEST_STATUS_REJECT)].includes(Number(this.state?.signatureRequestInfo?.signRequest?.signRequestStatus?.id))}
          onWarningClose={this.handleWarningClose}
          onWarningReturnInbox={this.handleWarningReturnInbox}
        />
      )
    }
  }
}

export default withTranslation()(DetailSignatureAction)